import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/iconite/mesaj.png'


const _withScopeId = n => (_pushScopeId("data-v-e73bceac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex__column--center",
  style: {"background-color":"transparent"}
}
const _hoisted_2 = { class: "ecran-container" }
const _hoisted_3 = { class: "div__product--img" }
const _hoisted_4 = { class: "app__title--medium" }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "ecran__details",
  style: {"position":"relative"}
}
const _hoisted_9 = {
  key: 0,
  class: "ecran__sizes"
}
const _hoisted_10 = { class: "app__label--medium text-weight-bold" }
const _hoisted_11 = { class: "card__dimensiuni" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "app__label--medium text-weight-bold" }
const _hoisted_14 = { class: "card__dimensiuni" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "app__label--medium text-weight-bold" }
const _hoisted_17 = { class: "card__dimensiuni" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "app__label--medium text-weight-bold" }
const _hoisted_20 = { class: "card__dimensiuni" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "app__label--medium text-weight-bold" }
const _hoisted_23 = { class: "card__dimensiuni" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "app__label--medium text-weight-bold" }
const _hoisted_26 = { class: "card__dimensiuni" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "app__label--medium text-weight-bold" }
const _hoisted_29 = { class: "card__dimensiuni" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "app__label--medium text-weight-bold" }
const _hoisted_32 = { class: "card__dimensiuni" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 1,
  class: "ecran__sizes"
}
const _hoisted_35 = { style: {"display":"flex","justify-content":"flex-start","padding-top":"2rem","padding-bottom":"2rem","padding-right":"2rem","min-height":"7rem"} }
const _hoisted_36 = { style: {"font-weight":"bold","font-size":"1.2rem"} }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold","font-size":"1.2rem"} }, "KG", -1))
const _hoisted_38 = { style: {"font-weight":"bold","font-size":"1rem"} }
const _hoisted_39 = {
  key: 3,
  style: {"display":"flex","align-items":"center","gap":"8px"}
}
const _hoisted_40 = { style: {"font-size":"1rem"} }
const _hoisted_41 = { key: 4 }
const _hoisted_42 = { style: {"color":"red"} }
const _hoisted_43 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_44 = {
  key: 5,
  style: {"display":"flex","flex-direction":"column","padding-top":"2rem","padding-bottom":"2rem","padding-right":"2rem"}
}
const _hoisted_45 = { class: "app__label--medium" }
const _hoisted_46 = { style: {"display":"flex","justify-content":"center","padding-top":"2rem","padding-bottom":"2rem"} }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"30px","height":"30px","display":"flex","justify-content":"left","align-items":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"position":"relative","zoom":"0.7","width":"36px","height":"36px"}
  })
], -1))
const _hoisted_48 = {
  key: 1,
  class: "app__label--medium"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HierarchicalChainBrowseHeader = _resolveComponent("HierarchicalChainBrowseHeader")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_circular_progress = _resolveComponent("q-circular-progress")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_HierarchicalChainBrowseHeader, {
      hierarchicalChain: _ctx.paramArticles.hierarchicalChain,
      typeOfAccess: _ctx.typeOfAccess
    }, null, 8, ["hierarchicalChain", "typeOfAccess"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$i18n.locale == 'de' ? _ctx.paramArticles.categoryNameDe : _ctx.$i18n.locale == 'ro' ? _ctx.paramArticles.categoryNameRo : _ctx.$i18n.locale == 'en' ? _ctx.paramArticles.categoryNameEn : _ctx.paramArticles.categoryNameHu), 1),
          _createVNode(_component_q_img, {
            src: _ctx.urlToJPG+'/'+_ctx.pidCategory,
            class: "category__img",
            fit: "scale-down",
            ratio: "1"
          }, null, 8, ["src"]),
          (_ctx.existaArticole)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                dense: "",
                "no-caps": "",
                style: {"max-width":"12rem","margin":"1rem auto 0 auto","background-color":"#9b7d32","color":"white"},
                onClick: _ctx.toggleArticleInFavorites
              }, {
                default: _withCtx(() => [
                  (_ctx.articleIsOnFavorites)
                    ? (_openBlock(), _createBlock(_component_q_icon, {
                        key: 0,
                        left: "",
                        size: "1.3rem",
                        name: "favorite",
                        style: {"color":"white"}
                      }))
                    : (_openBlock(), _createBlock(_component_q_icon, {
                        key: 1,
                        left: "",
                        size: "1.2rem",
                        name: "favorite_border",
                        style: {"color":"white"}
                      })),
                  (_ctx.articleIsOnFavorites)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Adaugat la favorite"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('message.add_to_favorite')), 1))
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _hoisted_7
        ]),
        (_ctx.existaArticole)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_ctx.areArticlesWithoutDimensions == false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_ctx.paramArticles.withWidth=='y' )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          style: _normalizeStyle([{"padding-top":"1rem"}, { order: _ctx.paramArticles.positionWidth }])
                        }, [
                          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('message.width')) + " (mm)", 1),
                          _createElementVNode("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramArticles.arrWidth, (size) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: size,
                                class: _normalizeClass(["card__dimensiuni--item", { 'card__dimensiuni--item--available': _ctx.isWidthAvailable(size),'card__dimensiuni--item--selected':_ctx.selectedWidth==size  }]),
                                onClick: ($event: any) => (_ctx.setSize('w',size))
                              }, _toDisplayString(size), 11, _hoisted_12))
                            }), 128))
                          ])
                        ], 4))
                      : _createCommentVNode("", true),
                    (_ctx.paramArticles.withThickness=='y')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          style: _normalizeStyle([{"padding-top":"1rem"}, { order: _ctx.paramArticles.positionThickness }])
                        }, [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('message.thickness')) + " (mm)", 1),
                          _createElementVNode("div", _hoisted_14, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramArticles.arrThickness, (size) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: size,
                                class: _normalizeClass(["card__dimensiuni--item", { 'card__dimensiuni--item--available': _ctx.isThicknessAvailable(size),'card__dimensiuni--item--selected':_ctx.selectedThickness==size  }]),
                                onClick: ($event: any) => (_ctx.setSize('t',size))
                              }, _toDisplayString(size), 11, _hoisted_15))
                            }), 128))
                          ])
                        ], 4))
                      : _createCommentVNode("", true),
                    (_ctx.paramArticles.withDiameter=='y')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          style: _normalizeStyle([{"padding-top":"1rem"}, { order: _ctx.paramArticles.positionDiameter }])
                        }, [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('message.diameter')) + " (mm)", 1),
                          _createElementVNode("div", _hoisted_17, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramArticles.arrDiameter, (size) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: size,
                                class: _normalizeClass(["card__dimensiuni--item", { 'card__dimensiuni--item--available': _ctx.isDiameterAvailable(size),'card__dimensiuni--item--selected':_ctx.selectedDiameter==size  }]),
                                onClick: ($event: any) => (_ctx.setSize('d',size))
                              }, _toDisplayString(size), 11, _hoisted_18))
                            }), 128))
                          ])
                        ], 4))
                      : _createCommentVNode("", true),
                    (_ctx.paramArticles.withHeight=='y')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 3,
                          style: _normalizeStyle([{"padding-top":"1rem"}, { order: _ctx.paramArticles.positionHeight }])
                        }, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('message.height')) + " (mm)", 1),
                          _createElementVNode("div", _hoisted_20, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramArticles.arrHeight, (size) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: size,
                                class: _normalizeClass(["card__dimensiuni--item", { 'card__dimensiuni--item--available': _ctx.isHeightAvailable(size),'card__dimensiuni--item--selected':_ctx.selectedHeight==size  }]),
                                onClick: ($event: any) => (_ctx.setSize('h',size))
                              }, _toDisplayString(size), 11, _hoisted_21))
                            }), 128))
                          ])
                        ], 4))
                      : _createCommentVNode("", true),
                    (_ctx.paramArticles.withAlloy=='y')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 4,
                          style: _normalizeStyle([{"padding-top":"1rem"}, { order: _ctx.paramArticles.positionAlloy }])
                        }, [
                          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('message.aliaj')), 1),
                          _createElementVNode("div", _hoisted_23, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramArticles.arrAlloy, (size) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: size,
                                class: _normalizeClass(["card__dimensiuni--item", { 'card__dimensiuni--item--available': _ctx.isAlloyAvailable(size),'card__dimensiuni--item--selected':_ctx.selectedAlloy==size  }]),
                                onClick: ($event: any) => (_ctx.setSize('a',size))
                              }, _toDisplayString(size), 11, _hoisted_24))
                            }), 128))
                          ])
                        ], 4))
                      : _createCommentVNode("", true),
                    (_ctx.paramArticles.withLength=='y')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 5,
                          style: _normalizeStyle([{"padding-top":"1rem"}, { order: _ctx.paramArticles.positionLength }])
                        }, [
                          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('message.length')) + " " + _toDisplayString(_ctx.isMeter() ? '(M)' : '(mm)'), 1),
                          _createElementVNode("div", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramArticles.arrLength, (size) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: size,
                                class: _normalizeClass(["card__dimensiuni--item", { 'card__dimensiuni--item--available': _ctx.isLengthAvailable(size),'card__dimensiuni--item--selected':_ctx.selectedLength==size }]),
                                onClick: ($event: any) => (_ctx.setSize('l',size))
                              }, _toDisplayString(size), 11, _hoisted_27))
                            }), 128))
                          ])
                        ], 4))
                      : _createCommentVNode("", true),
                    (_ctx.paramArticles.withEyes=='y')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 6,
                          style: _normalizeStyle([{"padding-top":"1rem"}, { order: _ctx.paramArticles.positionEyes }])
                        }, [
                          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('message.eyes')) + " (mm)", 1),
                          _createElementVNode("div", _hoisted_29, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramArticles.arrType, (size) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: size,
                                class: _normalizeClass(["card__dimensiuni--item", { 'card__dimensiuni--item--available': _ctx.isTypeAvailable(size),'card__dimensiuni--item--selected':_ctx.selectedEyes==size }]),
                                onClick: ($event: any) => (_ctx.setSize('k',size))
                              }, _toDisplayString(size), 11, _hoisted_30))
                            }), 128))
                          ])
                        ], 4))
                      : _createCommentVNode("", true),
                    (_ctx.paramArticles.withEyes2=='y')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 7,
                          style: _normalizeStyle([{"padding-top":"1rem"}, { order: _ctx.paramArticles.positionEyes2 }])
                        }, [
                          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('message.eyes')) + " 2 (mm)", 1),
                          _createElementVNode("div", _hoisted_32, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramArticles.arrEyes2, (size) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: size,
                                class: _normalizeClass(["card__dimensiuni--item", { 'card__dimensiuni--item--available': _ctx.isEyes2Available(size),'card__dimensiuni--item--selected':_ctx.selectedEyes2==size }]),
                                onClick: ($event: any) => (_ctx.setSize('e',size))
                              }, _toDisplayString(size), 11, _hoisted_33))
                            }), 128))
                          ])
                        ], 4))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.areArticlesWithoutDimensions)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createVNode(_component_q_table, {
                      class: "my-sticky-header-table",
                      title: "",
                      rows: _ctx.products,
                      columns: _ctx.columns,
                      "visible-columns": _ctx.visibleColumns,
                      "rows-per-page-options": [10, 20],
                      pagination: _ctx.myPagination,
                      "row-key": "name",
                      flat: "",
                      "hide-header": "",
                      "hide-bottom": "",
                      "wrap-cells": "",
                      "virtual-scroll": ""
                    }, {
                      body: _withCtx((props) => [
                        _createVNode(_component_q_tr, { props: props }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_td, {
                              key: "name",
                              props: props,
                              onClick: ($event: any) => (_ctx.selectProduct(props.row.product_code)),
                              style: _normalizeStyle({'background-color': props.row.product_code == _ctx.selectedProductCode ? '#DAF3F3':'white'})
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$i18n.locale == 'de' ? props.row.product_name_de : _ctx.$i18n.locale == 'ro' ? props.row.product_name_ro : _ctx.$i18n.locale == 'en' ? props.row.product_name_en : props.row.product_name_hu), 1)
                              ]),
                              _: 2
                            }, 1032, ["props", "onClick", "style"])
                          ]),
                          _: 2
                        }, 1032, ["props"])
                      ]),
                      _: 1
                    }, 8, ["rows", "columns", "visible-columns", "pagination"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_35, [
                (_ctx.selectedSize.um1 && _ctx.selectedSize.um1.length>0)
                  ? (_openBlock(), _createBlock(_component_q_input, {
                      key: 0,
                      modelValue: _ctx.qUm1,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.qUm1) = $event)),
                        _cache[1] || (_cache[1] = ($event: any) => (_ctx.coreleazaUm1Um2('um1')))
                      ],
                      modelModifiers: { number: true },
                      type: "number",
                      outlined: "",
                      "label-slot": "",
                      min: "0",
                      style: {"max-width":"10rem"},
                      error: _ctx.ErrorRuleIntegerNumberBuc
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.selectedSize.um1), 1)
                      ]),
                      error: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.error6m').replace('xx', _ctx.selectedLength + ' ' + _ctx.selectedSize.um1)), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "error"]))
                  : _createCommentVNode("", true),
                (_ctx.selectedSize.um2 && _ctx.selectedSize.um2.length>0 && _ctx.selectedSize.um2 != 0)
                  ? (_openBlock(), _createBlock(_component_q_input, {
                      key: 1,
                      modelValue: _ctx.qUm2,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event: any) => ((_ctx.qUm2) = $event)),
                        _cache[3] || (_cache[3] = ($event: any) => (_ctx.coreleazaUm1Um2('um2')))
                      ],
                      modelModifiers: { number: true },
                      type: "number",
                      readonly: "",
                      outlined: "",
                      "label-slot": "",
                      min: "0",
                      style: {"max-width":"10rem","margin-left":"1rem"}
                    }, {
                      label: _withCtx(() => [
                        _hoisted_37
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.selectedSize.cuDebitare)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'card__debitare__options_mobile' : 'card__debitare__options')
                  }, [
                    _createVNode(_component_q_toggle, {
                      modelValue: _ctx.dorescDebitare,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dorescDebitare) = $event)),
                      label: _ctx.$t('message.want_cutting')
                    }, null, 8, ["modelValue", "label"]),
                    (_ctx.selectedSize.cuDebitare && _ctx.dorescDebitare)
                      ? (_openBlock(), _createBlock(_component_q_input, {
                          key: 0,
                          maxlength: "1000",
                          type: "textarea",
                          autogrow: "",
                          counter: "",
                          "label-slot": "",
                          outlined: "",
                          modelValue: _ctx.inputFreeTextComments,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputFreeTextComments) = $event)),
                          class: "input--desire"
                        }, {
                          label: _withCtx(() => [
                            _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('message.cutting_title')), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              ((_ctx.selectedSize.um1 || _ctx.selectedSize.um2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("span", _hoisted_40, [
                      _createTextVNode(_toDisplayString(_ctx.$t('message.status')) + ": ", 1),
                      _createElementVNode("span", {
                        style: _normalizeStyle('color: ' +_ctx.labelStockColor)
                      }, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.labelStock) + ".", 1)
                      ], 4)
                    ]),
                    (_ctx.loadingStock)
                      ? (_openBlock(), _createBlock(_component_q_circular_progress, {
                          key: 0,
                          indeterminate: "",
                          rounded: "",
                          size: "24px",
                          color: "black"
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.dorescDebitare)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("span", _hoisted_42, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.remarks_cutting')), 1),
                      _hoisted_43
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!(_ctx.selectedSize.cuDebitare && _ctx.dorescDebitare))
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('message.remarks')), 1),
                    _createVNode(_component_q_input, {
                      maxlength: "1000",
                      type: "textarea",
                      autogrow: "",
                      counter: "",
                      class: "input--desire",
                      outlined: "",
                      modelValue: _ctx.inputFreeTextComments,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inputFreeTextComments) = $event)),
                      placeholder: _ctx.$t('message.item_details'),
                      dense: "",
                      "bg-color": "white"
                    }, null, 8, ["modelValue", "placeholder"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_46, [
                (_ctx.labelBtnAdaugaBasket===_ctx.$t('message.add_in_basket'))
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      style: {"color":"white","background-color":"#9b7d32"},
                      icon: "shopping_cart",
                      "no-caps": "",
                      label: _ctx.$t('message.add_in_basket'),
                      onClick: _ctx.addProductToBasket
                    }, null, 8, ["label", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.labelBtnAdaugaBasket===_ctx.$t('message.add_to_request'))
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      style: {"color":"white","background-color":"#9b7d32"},
                      icon: "shopping_cart",
                      "no-caps": "",
                      label: _ctx.$t('message.add_to_request'),
                      onClick: _ctx.addProductToCerere
                    }, null, 8, ["label", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_q_btn, {
                flat: "",
                "no-caps": "",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openContact())),
                style: {"color":"#273233"},
                "no-wrap": ""
              }, {
                default: _withCtx(() => [
                  _hoisted_47,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('message.article_not_found')), 1)
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_48, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('message.we_are_sorry')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('message.contact_sales_manager')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('message.thanks')), 1)
            ]))
      ])
    ])
  ]))
}